import { motion } from "framer-motion";

const Footer = () => {
  return (
    <motion.footer
      className="fixed bottom-0 left-0 w-full py-0.5 bg-black text-white text-center text-lg shadow-md"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <p className="opacity-80 hover:opacity-100 transition-opacity">
        © {new Date().getFullYear()} <span className="font-semibold">Nachiketa Kumar</span>. All rights reserved.
      </p>
    </motion.footer>
  );
};

export default Footer;
